import { Component } from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Col} from 'react-bootstrap';
import ArrowButton from '../common/button-arrow';
import { deletePage } from '../../actions/pages';

const linksMap = {
  'my-profile': '/my-profile',
  login: '/',
  'request-pin': '/reset-password',
  'enter-pin': '/enter-pin',
  'enter-security-questions': '/seq-questions',
  'set-new-password': '/new-password',
  'outlet-validation': '/registration/outlet',
  'about-you': '/registration/about-you',
  'your-store': '/registration/your-store',
  'store-summary': '/store_summary',
  'store-details': '/store-details/:id',
  'my-staff': '/my-staff',
  'new-order': '/order/new',
  'order-confirmation': '/order/:id/confirm',
  'how-to-earn': '/how-to-earn',
  'store-performance': '/admin/store-performances',
  'points-statement': '/admin/points-statement',
  'staff-rewards': '/staff-rewards',
  'personal-rewards-opted-out': '/personal-rewards',
  'personal-rewards-opted-in': '/personal-rewards',
  'contact-us-pre-login': '/contact',
  'contact-us-post-login': '/contact-us',
  'my-messages': '/my-messages',
  'about-ignite': '/about-ignite'
};

class OnePage extends Component {
  onDeleteClicked = () => {
    const { dispatch, page } = this.props;

    dispatch(deletePage(page.id));
  };

  render() {
    if (!window.location.origin) {
      window.location.origin =
        `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    }

    const { page } = this.props;
    const link = page.slug;
    const currentLink = page.group === 'Content' ? link.replace(new RegExp('_', 'g'), '-') : linksMap[page.slug];
    const fullLink = `${window.location.origin}/${currentLink || ''}`;
    const details = `/admin/pages-add-edit/${page.id}`;

    return (
      <div>
        <Col md={12}>
          <div className="one-page">
            <Col md={3}>
              {page.name}
            </Col>
            <Col md={3}>
              <Link target="_blank" to={`/content-page/edit/${link}`}>
                {fullLink}
              </Link>
            </Col>
            {page.group === 'Content' && (
              <Col md={6}>
                <ArrowButton
                  arrow={false}
                  className="float-end"
                  onClick={this.onDeleteClicked}
                  permissions={{
                    action: 'destroy',
                    subjectClass: 'Page',
                  }}
                  submit={false}
                >
                  Delete
                </ArrowButton>
                <Link to={details}>
                  <ArrowButton
                    arrow={false}
                    className="float-end"
                    color="grey"
                    permissions={{
                      action: 'update',
                      subjectClass: 'Page',
                    }}
                    submit={false}
                  >
                    Edit
                  </ArrowButton>
                </Link>
              </Col>
            )}
          </div>
        </Col>
      </div>
    );
  }
}

export default connect()(OnePage);
